import { Grid } from "@mui/material";

interface TabPanelProps {
  index: number;
  value: number;
  children: React.ReactNode;
}

const TabPanel = ({ value, index, children }: TabPanelProps): JSX.Element => {
  return <Grid hidden={value !== index}>{value === index && children}</Grid>;
};

export default TabPanel;
